

import Vue from "vue";
import AppItemOption from "../../account/PriceItemOption.vue";
export default Vue.extend({

	components: {
		AppItemOption,
	}
});

